import { render, staticRenderFns } from "./TeachinSettings.vue?vue&type=template&id=ab2d37fa&scoped=true&"
import script from "./TeachinSettings.vue?vue&type=script&lang=js&"
export * from "./TeachinSettings.vue?vue&type=script&lang=js&"
import style0 from "./TeachinSettings.vue?vue&type=style&index=0&id=ab2d37fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab2d37fa",
  null
  
)

export default component.exports